import { UseMutateFunction } from '@tanstack/react-query';

import {
	IGoldenSettingsImportedFile,
} from '@components/routes/CmModule/ConsistencyCheck/GoldenSettingsForm/AttachGoldenSettings/AttachGoldenSettings';
import {
	IGoldenSettingsImportFile,
} from '@components/routes/CmModule/ConsistencyCheck/GoldenSettingsForm/GoldenSettingsForm';

import { useMutation } from '@hooks/reactQuery';

import { executeGoldenSettingsImport, getGoldenSettingsMavenirConfigTree } from '@api/goldenSettings';

import { TGoldenSettingsSetTypeDTO } from '@interfaces/cmModule/dto/goldenSettingsDTO';
import { IGoldenSettingsTree } from '@interfaces/cmModule/goldenSettings';
import { IDefaultExportResponse } from '@interfaces/common/response';

import { GOLDEN_SETTING_IMPORT } from '@constants/queryKeys';

interface ITreeImportResponse {
	importData: IDefaultExportResponse;
	configData: IGoldenSettingsTree;
	name: string;
}

interface IUseMutateGoldenSettingsImportReturnType {
	importGoldenSettings: UseMutateFunction<any, any, IGoldenSettingsImportedFile, any>;
	isLoadingImportGoldenSettings: boolean;
}

export const useMutateGoldenSettingsImport = (
	params: TGoldenSettingsSetTypeDTO,
	setSettingsConfig: (data: Partial<IGoldenSettingsImportFile>) => void,
): IUseMutateGoldenSettingsImportReturnType => {
	const {
		mutate: importGoldenSettings,
		isLoading,
	} = useMutation<IGoldenSettingsImportedFile>({
		mutationKey: [GOLDEN_SETTING_IMPORT],
		mutationFn: async (importFile: IGoldenSettingsImportedFile) => {
			const { importId, name } = importFile;

			const importData = await executeGoldenSettingsImport({ importId: importId, ...params });
			const configData = await getGoldenSettingsMavenirConfigTree({
				...params,
				importId: importData.importId,
			});

			return { importData, configData, name };
		},
		onSuccess: ({
			configData,
			importData,
			name,
		}: ITreeImportResponse) => {
			setSettingsConfig({
				tree: configData.moTree,
				importFileName: name,
				rawData: undefined,
				importId: importData.importId,
			});
		},
	});

	return {
		importGoldenSettings,
		isLoadingImportGoldenSettings: isLoading,
	};
};
